import userPlaceholder from "../../../assets/images/userPlaceholder.png";
import { getProfilePictureUrl } from "../../../shared/utils/profilePictureUrl";

export interface ProfilePictureProps {
	userId: string;
	avatarVersion: number | null;
	profilePictureUrl?: string | null;
	className: string;
}

const ProfilePicture: React.FC<ProfilePictureProps> = ({
	userId,
	avatarVersion,
	profilePictureUrl,
	className,
}) => {
	const src = getProfilePictureUrl(userId, avatarVersion, profilePictureUrl);

	return (
		<img
			className={className}
			src={src || userPlaceholder}
			onError={(e) => (e.currentTarget.src = userPlaceholder)}
		/>
	);
};

export default ProfilePicture;
